module.exports = __webpack_public_path__ + "static/media/flower_top@2x.6bc03823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/greeting/flower_top@2x.png
// module id = 401
// module chunks = 0